import { toast } from 'sonner';

type ToastVariant = 'error' | 'warning' | 'success' | 'info';

const recentToasts = new Map<string, ReturnType<typeof setTimeout>>();

export function notify(input: {
  kind: string;
  symbol?: string | null;
  variant: ToastVariant;
  title: string;
  description?: string | undefined;
  block?: boolean;
}): void {
  const key = `${input.kind}:${input.symbol ?? ''}`;
  if (recentToasts.has(key)) return;

  const timeout = setTimeout(() => {
    recentToasts.delete(key);
  }, 10_000);
  recentToasts.set(key, timeout);

  const options = {
    description: input.description,
    duration: input.block ? 8_000 : 5_000,
  };

  if (input.variant === 'error') toast.error(input.title, options);
  if (input.variant === 'warning') toast.warning(input.title, options);
  if (input.variant === 'success') toast.success(input.title, options);
  if (input.variant === 'info') toast.info(input.title, options);
}

export function resetToastDeduplicationForTest(): void {
  for (const timeout of recentToasts.values()) {
    clearTimeout(timeout);
  }
  recentToasts.clear();
}
